import {Component, OnInit} from '@angular/core';
import {firstValueFrom, map, Observable} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {select, Store} from "@ngrx/store";
import {AppState} from "../../../store/reducers";
import {ProfileObject} from "../../login/login.graphql";
import {StorageService} from "../../../services/storage.service";
import {initializedPageableParameter} from "../../../interfaces/global.interface";
import {AuthService} from "../../../services/auth.service";
import * as fromGraphql from "../../../store/entities/citizens/my-requested-services/my-requested-services.graphql";
import {citizenGetFormResponses,} from "../../../store/entities/service-management/form-response/form-response.actions";
import {
  selectModifiedFromResponses
} from "../../../store/entities/service-management/form-response/form-response.selectors";
import {FormResponse} from "../../../store/entities/service-management/form-response/form-response.model";
import {Apollo} from "apollo-angular";
import {NotificationService} from "../../../services/notification.service";
import {GET_CITIZEN_PROFILE_UPGRADE_TO_SERVANT_CHECK} from "../../user-profile/user-profile.graphql";
import {
  UpdatePublicServantComponent
} from "../../../shared/components/update-public-servant/update-public-servant.component";
import {SettingsService} from "../../../services/settings.service";

@Component({
  selector: 'app-tgsd-client-requested-services-list',
  templateUrl: './tgsd-client-requested-services-list.component.html',
  styleUrls: ['./tgsd-client-requested-services-list.component.scss']
})
export class TgsdClientRequestedServicesListComponent implements OnInit {


  formResponses$: Observable<FormResponse[]>

  tableColumns: object

  requestWindowOpen = false;
  profile: ProfileObject
  servicesRequestSummary: any;
  pageParam: any = initializedPageableParameter;

  constructor(
    private translateService: TranslateService,
    private storageService: StorageService,
    private store: Store<AppState>,
    private authService: AuthService,
    private notificationService: NotificationService,
    private apollo: Apollo,
    private settingsService: SettingsService,
  ) {
    this.profile = this.storageService.getItem('profile');
  }

  ngOnInit(): void {
    this.tableColumns = {
      no: 'SN',
      modServiceName: 'Jina la Huduma',
      // modInstitution: 'Jina La Mtoa Huduma',
      modCategoryName: 'Kundi la Huduma',
      modSubmittedAt: 'Siku Iliyoombwa',
      modTrackingInfoStatus: 'Hali',
      actions: 'Hatua',

    }

    this.authService.monitorRefreshToken()

    this.getData()
    this.formResponses$ = this.store.pipe(select(selectModifiedFromResponses))
    this.loadServiceStats()
    this.checkUpgradeToServantEligibility().then(eligible => {
      if (eligible) {
        this.settingsService.openDialogModal({ width: '450px', component: UpdatePublicServantComponent, data: null });
      }
    });
  }


  requestService() {
    this.requestWindowOpen = !this.requestWindowOpen;
  }

  async checkUpgradeToServantEligibility(): Promise<boolean> {
    return await this.apollo.query({
      query: GET_CITIZEN_PROFILE_UPGRADE_TO_SERVANT_CHECK,
      fetchPolicy: 'network-only',
      variables: {}
    }).pipe(
      this.notificationService.catchError('Error Checking User profile'),
      map((response) => {
        const result = Object.values(response)[0]?.getCitizenProfile;
        if (result?.response?.status) {
          return !result.data.citizenServantAttempt && (result.data.citizenType !== 'Foreigner')
        } else {
          this.notificationService.errorMessage(`${result?.response?.message} code: ${result?.response?.code}`);
          return false;
        }
      })
    ).toPromise();
  }

  async loadServiceStats() {
    try {
      const result:any = await firstValueFrom(this.apollo.query({
        query: fromGraphql.GET_MY_REQUESTED_SERVICES,
        fetchPolicy: 'network-only',
      }));

      const responseDataService = result?.data?.getMyServiceRequestsStats;
      this.servicesRequestSummary = responseDataService?.data;
      console.log(this.servicesRequestSummary);

      return responseDataService;
    } catch (error) {
      this.notificationService.catchError('Query Error');
      throw error;
    }
  }
  pageAble($event: any) {
    this.pageParam = $event;
    this.getData()
  }
  getData(){
    this.store.dispatch(citizenGetFormResponses(
      {
        pageNumber: this.pageParam.first + 1,
        itemsPerPage: this.pageParam.size,
      }
    ))
  }

}
